export const actions = {
    toggleIsSidebarActive({commit}, val) {
        commit('TOGGLE_IS_SIDEBAR_ACTIVE', !!val);
    },
    updateSidebarWidth({commit}, width) {
        commit('UPDATE_SIDEBAR_WIDTH', width);
    },
    updateStarredPage({commit}, payload) {
        commit('UPDATE_STARRED_PAGE', payload)
    },
    login({commit}, {authToken, user}) {
        commit('UPDATE_TOKEN', authToken);
        commit('UPDATE_USER', user);
    },
    updateUser({ commit }, user) {
        commit('UPDATE_USER', user);
    },
    logout({commit}) {
        commit('UPDATE_TOKEN', null);
        commit('UPDATE_USER', {});
    },
    updateDateRange({commit}, payload) {
        commit('UPDATE_DATE_RANGE', payload)
    },
    updateRelatorioComissoes({commit}, payload) {
        commit('UPDATE_RELATORIO_COMISSOES', payload);
    },
    updateDashboard({commit}, payload) {
        commit('UPDATE_DASHBOARD', payload);
    },
};
